/**
 * Where each role's portal starts.
 *
 * Public pages (the landing page, the disclaimer) are reachable while signed in, so they need to
 * know where "home" is for whoever is reading them — sending an admin to the marketing page is
 * indistinguishable from signing them out, because that page's only control is a customer Sign In
 * button. `App.js` holds the matching role -> *login* paths in `Protected`; that is a different
 * map (it answers "where does a signed-out visitor go"), which is why this is not merged with it.
 */
export const HOME_PATHS = {
  customer: "/customer",
  admin: "/admin",
  reviewer: "/advocate",
};

export function homePathFor(role) {
  return HOME_PATHS[role] || "/";
}
